import { render, staticRenderFns } from "./CajaCrud.vue?vue&type=template&id=150f20b2&scoped=true"
import script from "./CajaCrud.vue?vue&type=script&lang=js"
export * from "./CajaCrud.vue?vue&type=script&lang=js"
import style0 from "./CajaCrud.vue?vue&type=style&index=0&id=150f20b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150f20b2",
  null
  
)

export default component.exports